import { render, staticRenderFns } from "./WelcomeConfigForm.vue?vue&type=template&id=bbdcdc36&scoped=true"
import script from "./WelcomeConfigForm.vue?vue&type=script&lang=js"
export * from "./WelcomeConfigForm.vue?vue&type=script&lang=js"
import style0 from "./WelcomeConfigForm.vue?vue&type=style&index=0&id=bbdcdc36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdcdc36",
  null
  
)

export default component.exports